import * as React from 'react';

import {SidebarSection} from 'shells/setup/sidebar-section/sidebar-section';
import type {SidebarSectionLink} from 'shells/setup/sidebar-section/sidebar-section';

import type {TagType} from 'nutshell-graphql-types';

type Props = {
    activeTable: TagType;
    accountTagCount: number;
    accountTagsLoading: boolean;
    leadTagCount: number;
    leadTagsLoading: boolean;
    contactTagCount: number;
    contactTagsLoading: boolean;
    archivedTagCount: number;
    archivedTagsLoading: boolean;
};

export function TagsSidebarSection(props: Props) {
    const search = new URLSearchParams(window.location.search);
    const isArchived = search.get('archived') === 'true';

    const tabSegment = getTabSegment(props.activeTable);
    const labelForActive = getLabelForActive(props.activeTable);
    const countForActive = getCountForActive(
        props.activeTable,
        props.accountTagCount,
        props.contactTagCount,
        props.leadTagCount
    );
    const loadingForActive = getLoadingForActive(
        props.activeTable,
        props.accountTagsLoading,
        props.contactTagsLoading,
        props.leadTagsLoading
    );

    const tagsLinks: SidebarSectionLink[] = [
        {
            to: `/setup/tag/${tabSegment}`,
            label: labelForActive,
            isActive: !isArchived,
            count: countForActive,
            // @ts-expect-error
            isLoading: loadingForActive,
        },
        {
            to: `/setup/tag/${tabSegment}?archived=true`,
            label: 'Archived tags',
            type: 'archived',
            isActive: isArchived,
            count: props.archivedTagCount,
            // @ts-expect-error
            isLoading: props.archivedTagsLoading,
        },
    ];

    const isLoading = Boolean(loadingForActive && !isArchived);

    return <SidebarSection title='Tags' links={isLoading ? [] : tagsLinks} isLoading={isLoading} />;
}

function getTabSegment(activeTable: TagType): string {
    switch (activeTable) {
        case 'ACCOUNT':
            return 'company';
        case 'CONTACT':
            return 'person';
        case 'LEAD':
        default:
            return 'lead';
    }
}

function getLabelForActive(activeTable: TagType): string {
    switch (activeTable) {
        case 'ACCOUNT':
            return 'All company tags';
        case 'CONTACT':
            return 'All person tags';
        case 'LEAD':
        default:
            return 'All lead tags';
    }
}

function getCountForActive(
    activeTable: TagType,
    accountTagCount: number,
    contactTagCount: number,
    leadTagCount: number
): number {
    switch (activeTable) {
        case 'ACCOUNT':
            return accountTagCount;
        case 'CONTACT':
            return contactTagCount;
        case 'LEAD':
        default:
            return leadTagCount;
    }
}

function getLoadingForActive(
    activeTable: TagType,
    accountTagsLoading: boolean,
    contactTagsLoading: boolean,
    leadTagsLoading: boolean
): boolean {
    switch (activeTable) {
        case 'ACCOUNT':
            return accountTagsLoading;
        case 'CONTACT':
            return contactTagsLoading;
        case 'LEAD':
        default:
            return leadTagsLoading;
    }
}
